import { Button, Space } from "antd";
import { Link } from "react-router";
import Logo from "../../../../assets/images/Logo.svg";
import whyMe from "../../../../assets/images/home/whyMe.png";
import Title from "../../../../components/ui/Title";
import CircleCorrectIcon from "../_icons/CircleCorrectIcon";
import { whyChoiceUs } from "../constants";

export default function WhyUseUs() {
  return (
    <div className="container mini-container grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 items-center gap-10 py-12 lg:py-24">
      <div className="flex justify-center items-center w-full">
        <img
          className="h-auto lg:h-[580px] object-cover rounded-lg w-full"
          src={whyMe}
          alt="why_me_image"
        />
      </div>

      <div>
        <img className="h-20 relative -top-1" src={Logo} alt="logo" />

        <Title className="flex items-center flex-wrap">কেন বেছে নিবেন!</Title>

        <ul className="space-y-3 mt-6">
          {whyChoiceUs.map((el) => (
            <div className="flex justify-start items-center gap-4">
              <div>
                <CircleCorrectIcon className="text-xl" />
              </div>
              <div>
                <div className="justify-start text-theme-neutral-800 text-base lg:text-lg font-semibold">
                  {el.label}
                </div>
                <div className="justify-start text-theme-slate-700 text-base lg:text-lg font-normal">
                  {el.value}
                </div>
              </div>
            </div>
          ))}
        </ul>

        <Space align="center" size={20} className="mt-8">
          <Button
            type="primary"
            size="large"
            className=" !rounded-[100px] pt-1 text-base lg:text-lg font-medium"
          >
            পছন্দের চাকুরি খুঁজুন
          </Button>
          <Link to="/courses">
            <Button
              size="large"
              className="!border-theme-primary pt-1 !text-theme-primary !rounded-[100px] text-base lg:text-lg font-medium"
            >
              দক্ষতা বৃদ্ধি করুন
            </Button>
          </Link>
        </Space>
      </div>
    </div>
  );
}
